import React, { useState } from "react"
import { motion, useScroll, useMotionValueEvent } from "framer-motion"
import { styled, Typography } from "@mui/material"
import { useQuery } from "@apollo/client"
import GET_INTRO from "../Queries/getIntro"

const MainDiv = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  justifyContent: "flex-start",
  alignItems: "center",
  boxSizing: "border-box",
  position: "fixed",
  top: 0,
  width: "100%",
  backgroundColor: theme.palette.secondary.main,
  height: "80px",
  zIndex: 999,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    justifyContent: "space-between",
    height: "52px",
    gap: "0px",
  },
}))

export default function NavBar() {
  const { scrollY } = useScroll()
  const [hidden, setHidden] = useState(false)

  useMotionValueEvent(scrollY, "change", (latest) => {
    const previous = scrollY.getPrevious() ?? 0
    setHidden(latest > previous && latest > 150)
  })

  const { data, loading, error } = useQuery(GET_INTRO)

  if (loading) return null
  if (error) return <p>Error: {error.message}</p>

  const item = data?.introCollection?.items?.[0]
  if (!item) return null

  return (
    <MainDiv
      variants={{ visible: { y: 0 }, hidden: { y: "-80px" } }}
      animate={hidden ? "hidden" : "visible"}
      transition={{ duration: 0.35, ease: [0.6, 0.01, 0.05, 0.95] }}
    >
      <Typography
        variant="h6"
        color="primary"
        fontWeight={600}
        sx={{ letterSpacing: "-0.5px" }}
      >
        {item.name} {item.surname}
      </Typography>

      <Typography
        variant="h6"
        color="primary"
        sx={{
          letterSpacing: "-0.5px",
        }}
      >
        {item.header}
      </Typography>
    </MainDiv>
  )
}
